import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";
import { DepotId } from "../../types/depot";

export const lockersApiSlice = createApi({
  reducerPath: "lockersApiSlice",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["doorStatus"],
  endpoints: (builder) => ({
    openLocker: builder.mutation({
      query: ({
        depotId,
        door,
        token,
        orderItemId
      }: {
        depotId: DepotId;
        door: number;
        orderItemId?: string;
        token: string;
      }) => {
        return {
          url: orderItemId ? `/depot/${depotId}/doors/${door}?orderItemId=${orderItemId}` : `/depot/${depotId}/doors/${door}`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      // Opening a door changes its physical state; refresh getDoorStatus.
      invalidatesTags: ["doorStatus"],
    }),
    getDoorStatus: builder.query({
      query: ({ depotId, door }) => {
        return {
          url: `/depot/${depotId}/door/${door}/status`,
        };
      },
      providesTags: ["doorStatus"],
    }),
  }),
});

export const { useOpenLockerMutation, useGetDoorStatusQuery } = lockersApiSlice;
